import styled from 'styled-components';
import { Statistic as AntStatistic, Tooltip } from 'antd';

import { Icon, Pane } from 'components/common';
import { siNumber } from 'utils/number';

const Content = styled.div`
  display: flex;
  align-items: center;
  ${p => p.hasTooltip && 'cursor: help;'}
  > svg {
    margin-right: 10px;
  }

  ${p => p.theme.breakpoint.mobile} {
    .ant-statistic-title {
      display: none;
    }

    .ant-statistic-content {
      font-size: 18px;
    }
  }
`;

const Statistic = ({ icon, iconColor, tooltip, ...rest }) => {
  const statistic = icon ? (
    <AntStatistic
      {...rest}
      prefix={<Icon icon={icon} color={iconColor} size='lg' />}
      formatter={siNumber}
    />
  ) : (
    <AntStatistic {...rest} formatter={siNumber} />
  );

  // siNumber rounds anything over 999, so a tooltip is the only way back to the
  // figure the number came from. It wraps Content rather than the statistic so the
  // hover lands on a real DOM node.
  return (
    <Pane>
      {tooltip ? (
        <Tooltip title={tooltip}>
          <Content hasTooltip>{statistic}</Content>
        </Tooltip>
      ) : (
        <Content>{statistic}</Content>
      )}
    </Pane>
  );
};

Statistic.defaultProps = {
  iconColor: '#56B3C3',
};

export default Statistic;
